module.exports = __webpack_public_path__ + "static/media/user-hard-hat.eab27cd8.svg";